module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Heavy.2b129772.eot";